import * as _ from 'lodash'
import moment from 'moment'

export const createXAxis = (start: Date, end: Date): string[] => {
  const from = moment(start).startOf('date')
  const to = moment(end).startOf('date')
  return _.range(0, to.diff(from, 'days') + 1).map(amount => from.clone().add(amount, 'days').format('YYYY-MM-DD'))
}
